const initialState = {
  status: "invalid",
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "ISLAND_ZIP_CODE_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "ISLAND_ZIP_CODE_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "ISLAND_ZIP_CODE_FAILURE":
      return {
        ...state,
        status: "failure",
      };

    default:
      return state;
  }
};
